import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/contexts/auth";
import { useCredentialsClient } from "@/features/credentials/hooks/use-credentials-client";
import type { UpdateCredentialPayload } from "@/features/credentials/models/credential";
import { credentialsQueryKeys } from "@/features/credentials/queries/credentials-query-keys";

export function useUpdateCredentialMutation() {
  const queryClient = useQueryClient();
  const { productToken } = useAuth();
  const credentialsClient = useCredentialsClient();

  return useMutation({
    mutationFn: ({
      sport,
      organizationId,
      credentialId,
      payload,
    }: {
      sport: string;
      organizationId: string;
      credentialId: string;
      payload: UpdateCredentialPayload;
    }) =>
      credentialsClient.updateCredential({
        productToken: productToken as string,
        sport,
        organizationId,
        credentialId,
        payload,
      }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: credentialsQueryKeys.list({
          sport: variables.sport,
          organizationId: variables.organizationId,
        }),
      });
    },
  });
}
